'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: ', ';\n  align-items: center;\n  height: clamp(60px, 80px, 100px);\n  box-sizing: border-box;\n  width: 100%;\n  z-index: 10;\n  box-shadow: 0 2px 1px 0 ', ';\n  background-color: ', ';\n'], ['\n  display: grid;\n  grid-template-columns: ', ';\n  align-items: center;\n  height: clamp(60px, 80px, 100px);\n  box-sizing: border-box;\n  width: 100%;\n  z-index: 10;\n  box-shadow: 0 2px 1px 0 ', ';\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n  padding-left: 30px;\n  cursor: pointer;\n'], ['\n  ', '\n  padding-left: 30px;\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  border-radius: 20px;\n  background-color: ', ';\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  border-radius: 20px;\n  background-color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-radius: 50%;\n  background-color: ', ';\n  margin-left: 2px;\n  margin-right: 20px;\n  width: 24px;\n  height: 24px;\n'], ['\n  border-radius: 50%;\n  background-color: ', ';\n  margin-left: 2px;\n  margin-right: 20px;\n  width: 24px;\n  height: 24px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  justify-self: end;\n  ', '\n'], ['\n  justify-self: end;\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  justify-content: flex-end;\n'], ['\n  justify-content: flex-end;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  justify-self: center;\n'], ['\n  justify-self: center;\n']);

exports.default = HeaderBar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _menu = require('../lists/menu');

var _menu2 = _interopRequireDefault(_menu);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _colors = require('../../constants/colors');

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _isTablet = require('../../helpers/isTablet');

var _isTablet2 = _interopRequireDefault(_isTablet);

var _isDesktop = require('../../helpers/isDesktop');

var _isDesktop2 = _interopRequireDefault(_isDesktop);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _light = require('../../atoms/icons/logo/light');

var _light2 = _interopRequireDefault(_light);

var _dark = require('../../atoms/icons/logo/dark');

var _dark2 = _interopRequireDefault(_dark);

var _small = require('../../atoms/icons/logo/small');

var _small2 = _interopRequireDefault(_small);

var _logout = require('../../atoms/icons/logout');

var _logout2 = _interopRequireDefault(_logout);

var _sizes = require('../../constants/sizes');

var _alignments = require('../../constants/alignments');

var _LanguageToggle = require('../LanguageToggle');

var _LanguageToggle2 = _interopRequireDefault(_LanguageToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeaderBarWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
    var noOfElements = _ref.noOfElements,
        betaFeatureEnabled = _ref.betaFeatureEnabled;
    return betaFeatureEnabled ? 'repeat(' + noOfElements + ', minmax(0, 1fr)) 68px' : 'repeat(' + noOfElements + ', minmax(0, 1fr))';
}, _colors.Colors.StrokeLight, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor;
    return backgroundColor ? backgroundColor : _colors.Colors.LightMode;
});

var LogoContainer = _styledComponents2.default.div(_templateObject2, function (_ref3) {
    var mobile = _ref3.mobile;
    return mobile ? 'justify-self: end;' : 'justify-self: start;';
});

var CompanyContainer = _styledComponents2.default.div(_templateObject3, function (_ref4) {
    var color = _ref4.color;
    return color ? color : _colors.Colors.StrokeLight;
});

var CompanyAvatarContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject4, function (_ref5) {
    var color = _ref5.color;
    return color ? color : _colors.Colors.DarkMode;
});

var UserAccess = (0, _styledComponents2.default)(_menu2.default)(_templateObject5, function (_ref6) {
    var desktop = _ref6.desktop;
    return desktop && 'margin-right: 20px;';
});

var LogoutLink = (0, _styledComponents2.default)(_link2.default)(_templateObject6);

var LanguageToggleContainer = _styledComponents2.default.div(_templateObject7);

function HeaderBar(props) {
    var screenSize = (0, _getScreenSize2.default)();
    var isDisplayMobile = (0, _isMobile2.default)(screenSize);
    var isDisplayTablet = (0, _isTablet2.default)(screenSize);
    var isDisplayDesktop = (0, _isDesktop2.default)(screenSize);

    var userName = props.userName;
    var userType = props.userType;
    var companyName = props.companyName;
    var logoHeight = props.logoHeight;
    var logoWidth = props.logoWidth;
    var noOfElements = props.noOfElements || 3;
    var displayDarkLogo = props.displayDarkLogo;

    var betaFeatureEnabled = props.context.configuration && props.context.configuration.betaFeatureEnabled;

    //Add user access list
    var userAccessList = [{
        code: 'logout',
        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'HeaderBar.logout' }),
        clickEvent: function clickEvent() {
            props.context.doExpireSession();
            props.history.push('/');
        },
        type: 'menu'
    }];

    //Logo Link as per context configuration
    var logoLink = '/';
    if (!props.context.authenticated && props.context.configuration && props.context.configuration.corporateWeb) {
        logoLink = props.context.configuration.corporateWeb;
    } else if (props.context.authenticated && props.context.configuration && props.context.configuration.clientWeb) {
        logoLink = props.context.configuration.clientWeb;
    }

    return _react2.default.createElement(
        HeaderBarWrapper,
        {
            noOfElements: noOfElements,
            isDesktop: isDisplayDesktop,
            backgroundColor: props.backgroundColor,
            displayDarkLogo: displayDarkLogo,
            betaFeatureEnabled: betaFeatureEnabled
        },
        _react2.default.createElement(
            LogoContainer,
            { mobile: isDisplayMobile },
            _react2.default.createElement(
                _link2.default,
                { href: logoLink },
                isDisplayMobile ? _react2.default.createElement(_small2.default, null) : displayDarkLogo !== undefined && displayDarkLogo === true ? _react2.default.createElement(_dark2.default, { height: logoHeight, width: logoWidth }) : _react2.default.createElement(_light2.default, { height: logoHeight, width: logoWidth })
            )
        ),
        companyName && userType && _react2.default.createElement(
            _container2.default,
            { horizontalAlignment: _alignments.Alignments.center },
            _react2.default.createElement(
                CompanyContainer,
                { isMobile: isDisplayMobile },
                _react2.default.createElement(CompanyAvatarContainer, { isMobile: isDisplayMobile, color: props.brandAvatarColor }),
                _react2.default.createElement(_label2.default, { text: '' + companyName, color: props.companyNameColor, right: _sizes.Sizes.sm }),
                !isDisplayMobile && _react2.default.createElement(_label2.default, { text: '' + userType, color: props.userTypeColor, italic: true })
            )
        ),
        userName && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            !(isDisplayMobile || isDisplayTablet) ? _react2.default.createElement(UserAccess, {
                desktop: isDisplayDesktop,
                color: props.color,
                text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'HeaderBar.greeting', values: { name: userName } }),
                elements: userAccessList }) : _react2.default.createElement(
                LogoutLink,
                { right: _sizes.Sizes.sm, clickEvent: function clickEvent() {
                        props.context.doExpireSession();
                        props.history.push('/');
                    } },
                _react2.default.createElement(_logout2.default, null)
            )
        ),
        betaFeatureEnabled && _react2.default.createElement(
            LanguageToggleContainer,
            null,
            _react2.default.createElement(_LanguageToggle2.default, { context: props.context, color: props.color })
        )
    );
}